import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { replace } from '@kodit/core/shared';
import { Subscription } from 'rxjs';

@Component({
  selector: 'kodit-error-info-max-length',
  templateUrl: './error-info-max-length.component.html',
  styleUrls: ['./error-info-max-length.component.scss'],
})
export class ErrorInfoMaxLengthComponent implements OnInit, OnDestroy {
  /** Props */
  private _sub = new Subscription();
  initMsg: string =
    'Polje može imati najviše #MAX karaktera, a trenutno ima #CURR';
  errorMsg: string;

  /** I/O */
  @Input() formCtrl: AbstractControl;

  constructor() {}

  ngOnInit(): void {
    this.setErrorMsg();

    this._sub = this.formCtrl.valueChanges.subscribe((newValue) => {
      this.setErrorMsg();
    });
  }

  private setErrorMsg() {
    if (this.formCtrl.errors?.['maxlength']) {
      this.errorMsg = replace(
        this.initMsg,
        '#CURR',
        this.formCtrl.errors?.['maxlength']?.actualLength
      ).replace('#MAX', this.formCtrl.errors?.['maxlength']?.requiredLength);
    }
  }

  ngOnDestroy(): void {
    this._sub.unsubscribe();
  }
}
